<template>
  <div>
    <v-tooltip bottom v-if="!(configExcel && configExcel.isHidden)">
      <template #activator="on">
        <font-awesome-icon v-on="on.on" @click="download()" small :icon="['far', 'file-excel']" class="ml-2 iconColor"/>
        <!--<v-icon v-on="on.on" @click="download()" small class="ml-2 mb3px iconColor">far fa-file-excel</v-icon>-->
      </template>
      <span v-if="configExcel && configExcel.btnName && configExcel.btnName.length > 0">{{configExcel.btnName}}</span>
    </v-tooltip>
    <DialogNotice ref="dlg"></DialogNotice>
  </div>
</template>

<script>
import Vue from 'vue'
import swal from 'sweetalert2'
import DialogNotice from './../module/dialogs/DialogNotice'
export default {
  name: 'BtnDownloadIcon',
  components: {DialogNotice},
  props: ['configExcel', 'balance', 'name', 'fileName','isPeergroup', 'balanceArray'],
  methods: {
    open: function () {
    },
    onDownloadError: function (data) {
      Vue.prototype.$api.debug('onDownloadError', data)
      Vue.prototype.$api.hideIdle()
      swal(Vue.i18n.translate('DIALOG_TEXT_ERROR_DOWNLOAD_DOCUMENT'))
    },
    onDownloaded: function (data) {
      Vue.prototype.$api.debug('onDownloaded', data)
      Vue.prototype.$api.hideIdle()
    },
    download: function (item) {
      Vue.prototype.$api.debug('download', this.fileName)

      if (!Vue.prototype.$api.hasProduct('hasRightExport')) {
        Vue.prototype.$api.debug('missing right to export files')
        this.$refs.dlg.show({
          title: Vue.i18n.translate('DIALOG_TITLE_MISSING_HAS_EXPORT'),
          text: Vue.i18n.translate('DIALOG_TEXT_MISSING_HAS_EXPORT')
        })
        return
      }
      Vue.prototype.$api.showIdle()

      this.configExcel.SAcompany = ''

      if (Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())) {
        this.configExcel.SAcompany = Vue.prototype.$api.balanceToString(Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId()))
      }

      if (this.configExcel.isPeergroup) {
        this.configExcel.SApeergroup = ''
        for (var index in Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId())) {
          var balance = Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId())[index]
          var bString = balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
          if (bString !== this.configExcel.SAcompany) {
            this.configExcel.SApeergroup += bString + ','
          }
        }
        this.configExcel.SApeergroup = this.configExcel.SApeergroup.substr(0, this.configExcel.SApeergroup.length - 1)
      } else {
        if ('' === this.configExcel.SAcompany) {
          if (this.balance) {
            this.configExcel.SAcompany = Vue.prototype.$api.balanceToString(this.balance)
          }

        }
      }
      let cmp = this
      let hideColumns = []
      let tableNames = ['total', 'aktiva', 'passiva', 'guv', 'aux']
      _.forEach(tableNames, function (tableName) {
        let headerConfigName = cmp.configExcel.configName + 'TC' + tableName
        let columns = Vue.prototype.storage.getStorage(headerConfigName,null)
        // console.log('columns', headerConfigName, columns)
        if (columns && columns.length > 0) {
          _.forEach(columns, function (col) {
            if (!col.isVisible) {
              hideColumns.push(col.meta.id)
            }
          })
        }
      })
      // console.log('hideColumns', hideColumns)
      if( hideColumns.length > 0) {
        this.configExcel.excelHideColumns = hideColumns
      }
      this.configExcel.fileName = this.fileName
      this.configExcel.sort = Vue.prototype.storage.tabVFSorted
      Vue.prototype.$api.exportFileToExcel(this.configExcel, this.onDownloaded, this.onDownloadError)
    }
  },
  data () {
    return {
      on: false
    }
  },
  mounted () {
    Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/BtnDownloadIcon.vue